import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Modal,
  Tooltip,
  Image,
  Skeleton,
  ConfigProvider,
  Row,
  Col,
  Button,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setIsOpenModalUE } from "../../../../../../../redux/features/upcoming_events/upcomingEventsSlice";

import ICalendar from "../../../../../../../assets/images/custom_svgs/ICalendar";
import IClock from "../../../../../../../assets/images/custom_svgs/IClock";
import ILocation from "../../../../../../../assets/images/custom_svgs/ILocation";
import IMic from "../../../../../../../assets/images/custom_svgs/IMic";
import defaultImage from "../../../../../../../assets/images/png/general/img_thumb_default.png";

import {
  whiteColor,
  teamMonitoringText,
  borderShowTeam,
  closeIconBackground,
  backgroundBorderShowTeam,
  ColorPrimary,
  ColorSecondary,
  colorTextTitle,
  colorTextDesc,
} from "../../../../../../../config/constant/color/index";

// for translate
import { useTranslation } from "react-i18next";
// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const ModalUpcomingEventDetail = ({ isMobileVersion }) => {
  const { t, i18n } = useTranslation();
  const isOpenModalUE = useSelector(
    (state) => state.upcoming_events.isOpenModalUE,
  );
  const eventDetailData = useSelector(
    (state) => state.upcoming_events.eventDetailData,
  );

  const dispatch = useDispatch();

  // const screens = useBreakpoint();
  // const isMobileVersion = screens.xs;
  const isScallingVersion =
    (window.innerWidth <= 991 && window.innerWidth >= 768) ||
    window.innerWidth === 581;

  const timeAreaEvents = (
    <div style={{ marginTop: isMobileVersion ? 18 : 0 }}>
      <Row
        style={{
          marginBottom: isMobileVersion ? 12 : 11,
          flexDirection: isMobileVersion ? "column" : "row",
          gap: isMobileVersion ? 12 : 0,
        }}
      >
        <Col
          span={isMobileVersion ? 24 : 13}
          style={{
            display: "flex",
            alignItems: isMobileVersion ? "center" : "flex-start",
            lineHeight: "normal",
          }}
        >
          <div
            style={{
              marginRight: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            <ICalendar width={16} height={16} fill={ColorPrimary} />
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "normal",
              alignItems: "center",
            }}
          >
            {eventDetailData.date_range}
          </div>
        </Col>
        <Col
          span={isMobileVersion ? 12 : 11}
          style={{
            display: "flex",
            alignItems: isMobileVersion ? "center" : "flex-start",
            lineHeight: "normal",
          }}
        >
          <div
            style={{
              marginRight: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            {isMobileVersion ? (
              <IClock width={16} height={16} fill={ColorPrimary} />
            ) : (
              <ILocation width={16} height={16} fill={ColorPrimary} />
            )}
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "normal",
              alignItems: "center",
            }}
          >
            {isMobileVersion
              ? eventDetailData.time_range
              : eventDetailData.location}
          </div>
        </Col>
      </Row>
      <Row
        style={{
          flexDirection: isMobileVersion ? "column" : "row",
          gap: isMobileVersion ? 12 : 0,
        }}
      >
        <Col
          span={isMobileVersion ? 24 : 13}
          style={{
            display: "flex",
            alignItems: isMobileVersion ? "center" : "flex-start",
            lineHeight: "normal",
          }}
        >
          <div
            style={{
              marginRight: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            {isMobileVersion ? (
              <ILocation width={16} height={16} fill={ColorPrimary} />
            ) : (
              <IClock width={16} height={16} fill={ColorPrimary} />
            )}
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "normal",
              alignItems: "center",
            }}
          >
            {isMobileVersion
              ? eventDetailData.location
              : eventDetailData.time_range}
          </div>
        </Col>
        <Col
          span={isMobileVersion ? 24 : 11}
          style={{
            display: "flex",
            alignItems: isMobileVersion ? "center" : "flex-start",
            lineHeight: "normal",
          }}
        >
          <div
            style={{
              marginRight: 8,
              display: "flex",
              alignItems: "center",
            }}
          >
            <IMic width={16} height={16} fill={ColorPrimary} />
          </div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "normal",
              alignItems: "center",
            }}
          >
            {eventDetailData.speaker}
          </div>
        </Col>
      </Row>
    </div>
  );

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Roboto",
          borderRadiusLG: isMobileVersion ? "16px" : "24px",
        },
      }}
    >
      <Modal
        className={
          isMobileVersion
            ? "modal-detail-upcoming-events mobile-version"
            : "modal-detail-upcoming-events"
        }
        open={isOpenModalUE}
        closeIcon={
          !isMobileVersion && (
            <div
              style={{
                padding: "5px 10px",
                background: closeIconBackground,
                borderRadius: "50%",
                border: "none",
              }}
              id="btn-view-close-detail-upcoming-events"
            >
              <CloseOutlined
                style={{
                  color: colorTextDesc,
                  fontSize: "14px",
                }}
              />
            </div>
          )
        }
        width={isScallingVersion ? `${585 * 0.9}px` : 564}
        onCancel={() => {
          setTimeout(() => {
            document
              .getElementById("content-popup-upcoming-events")
              .scrollTo(0, 0);
          }, 200);
          dispatch(setIsOpenModalUE(false));
        }}
        transitionName="ant-fade"
        keyboard
        centered
        footer={
          isMobileVersion && (
            <div style={{ marginTop: "16px" }}>
              <Button
                onClick={() => dispatch(setIsOpenModalUE(false))}
                role="button"
                className="btn btn-sm btn-block"
                style={{
                  background: ColorPrimary,
                  color: whiteColor,
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "14px",
                  width: "100%",
                  height: "40px",
                }}
              >
                Close
              </Button>
            </div>
          )
        }
        style={{
          borderRadius: "24px",
        }}
        title={!isMobileVersion && eventDetailData.title}
        destroyOnClose={isMobileVersion ? true : false}
      >
        <div
          id="content-popup-upcoming-events"
          style={{
            // maxHeight: isMobileVersion ? "400px" : "calc(100vh - 225px)",
            maxHeight: "calc(100vh - 225px)",
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: isMobileVersion ? 20 : 32,
            paddingBottom: eventDetailData.is_tentative === 1 ? 0 : 8,
            marginBottom: isMobileVersion ? 12 : "unset",
            paddingTop: 0,
            paddingLeft: isMobileVersion ? 20 : 0,
          }}
        >
          {!isMobileVersion && (
            <div
              style={{
                display: eventDetailData.thumbnail !== "" ? "block" : "none",
                marginBottom: 20,
              }}
            >
              <Image
                style={{ objectFit: "cover", borderRadius: 8 }}
                src={eventDetailData.thumbnail}
                preview={false}
                fallback={defaultImage}
                alt="Event Detail Thumbnail"
              />
            </div>
          )}
          {isMobileVersion && (
            <div style={{ marginBottom: 14 }}>
              <div
                style={{
                  display: eventDetailData.thumbnail !== "" ? "block" : "none",
                  marginBottom: 20,
                }}
              >
                <Image
                  style={{ objectFit: "cover", borderRadius: 8 }}
                  src={eventDetailData.thumbnail}
                  preview={false}
                  fallback={defaultImage}
                  alt="Event Detail Thumbnail"
                />
              </div>
              <div className="ant-modal-title">{eventDetailData.title}</div>
            </div>
          )}
          <div
            style={{
              marginBottom: isMobileVersion ? 0 : 23,
              fontSize: 14,
              color: isMobileVersion ? colorTextDesc : "unset",
              lineHeight: isMobileVersion ? "20px" : "unset",
            }}
          >
            {eventDetailData.desc}
          </div>
          {timeAreaEvents}
        </div>
        {/* {isMobileVersion && timeAreaEvents} */}
        <div
          className="footer-upcoming-events-detail"
          style={{
            background: "#FFF4EE",
            fontSize: 14,
            fontWeight: 500,
            color: "#C2272E",
            padding: 8,
            textAlign: "center",
            borderRadius: 4,
            marginTop: 24,
            marginRight: isMobileVersion ? 0 : 32,
            display: eventDetailData.is_tentative === 1 ? "block" : "none",
          }}
        >
          {t("feature.home.events.event_popup.tentative_notice")}
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalUpcomingEventDetail;
